import DashboardLayout from "@/layouts/dashboard/DashboardLayout";

import orders from "./orders";

export default [
  {
    path: "/followup-manager",
    component: DashboardLayout,
    meta: {
      middleware: ["auth"],
      roles: ["followup-manager"],
    },
    children: [
      ...orders,
    ],
  },
];
